// Define base color palette
export const colorPalette = {
  BaseWhite: "#FFFFFF",
  BaseBlack: "#0A0B0A",
  Primary: "#214A32",
  Secondary: "#FDF9F6",
  Success: "#22C55E",
  Warning: "#F59E0B",
  Error: "#EF4444",
  Info: "#3b82f6",
  Neutral:"#737373",
};
